/**
 * AppSelect / AppAsyncSelect
 * Wrappers padronizados sobre react-select com defaults do projeto:
 *   - isClearable (X para limpar seleção)
 *   - noOptionsMessage em PT-BR
 *   - loadingMessage em PT-BR
 *   - placeholder genérico
 *   - visual consistente com o resto do sistema
 *
 * Uso básico:
 *   import { AppSelect, AppAsyncSelect } from '../../common/AppSelect';
 *
 *   <AppSelect options={AREAS} onChange={...} placeholder="Selecione a área..." />
 *   <AppAsyncSelect loadOptions={carregarProgramas} onChange={...} placeholder="Buscar programa..." />
 */

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

const defaultProps = {
    isClearable: true,
    noOptionsMessage: () => 'Nenhuma opção encontrada',
    loadingMessage: () => 'Carregando...',
    placeholder: 'Selecione...',
    classNamePrefix: 'app-select',
};

export function AppSelect({ placeholder = 'Selecione...', ...props }) {
    return (
        <Select
            {...defaultProps}
            placeholder={placeholder}
            {...props}
        />
    );
}

export function AppAsyncSelect({ placeholder = 'Buscar...', ...props }) {
    return (
        <AsyncSelect
            {...defaultProps}
            cacheOptions
            defaultOptions
            placeholder={placeholder}
            {...props}
        />
    );
}

export default AppSelect;
